import React, { Component } from 'react';

interface Props {
  
}

interface State {
  
}

class VedioGallery extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      
    };
  }

  
  render() {
    return (
      <div>
        <h1>Hello from Vedio Gallery</h1>
      </div>
    );
  }
}

export default VedioGallery;